export interface Input {
  content: Marko.Body;
}

<div style={ "grid-area": "text" }>
  <${input.content}/>
</div>
